export const version = "contracts/5.8.0";
//# sourceMappingURL=_version.js.map